import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import Api from '../Api'
export const PageContext = React.createContext()

class PageProvider extends Component {

    constructor(props) {
        super(props)

        // async state setter 
        this.setAsyncState = (props) => {
            return new Promise((resolve, reject) => {
                this.setState(props, resolve())
            })
        }

        // init api
        this.api = new Api()
        this.api.userService.setLoginHandler(async (user) => {
            try {
                await this._setSession()
            } catch (error) {
                console.log("on login handler, Error:  ", error)
            }
        })
        this.api.userService.setLogoutHandler(async () => {
            try {
                const { history } = this.props
                await this._setSession()
                history.push('/login')
            } catch (error) {
                console.log("on logout handler, Error: ", error)
            }

        })

        // init state
        const initState = {
            ready: false,
            user: null,
            messages: null,
            ratedTickets: null,
            messageFilters: '',
            messagePage: 1
        }
        this.state = initState
        this.resetState = async () => {
            this.setAsyncState(initState)
        }

        this._initSession()
    }

    /**
     * init user session
     */
    async _initSession() {
        let user = null
        try {
            user = await this.api.userService.getUser()
        } catch (error) {
            console.log('init session eroor:', error)
        }

        await this.setAsyncState({ ready: true, user })
        await this.loadMessages()
    }

    /**
     * set/unset user session
     */
    async _setSession() {
        try {
            const user = this.api.userService.user
            if (!user) {
                await this.resetState()
                await this.setAsyncState({ ready: true })
            } else if (user) {
                await this.setAsyncState({ ready: true, user })
                await this.loadMessages()
            }
        } catch (error) {
            console.log("set user session error:", error)
        }
    }

    /**
     * load messages from api
     * @param {String} filters
     * @param {String} page
     */
    async loadMessages() {
        try {
            const { messageFilters, messagePage } = this.state
            const messages = await this.api.messageService.getMessages(messageFilters, messagePage)
            await this.setAsyncState({ messages })
        } catch (error) {
            console.log('LoadMessages Error: ', error)
        }
    }

    /**
     * set message filters
     */
    async setMessageFilters(filters) {
        try {
            await this.setAsyncState({ messageFilters: filters })
            this.loadMessages()
        } catch (error) {
            console.log('SetFiltersAndPage Error: ', error)
        }
    }

    /**
     * set message page
     */
    async setMessagePage(page) {
        try {
            await this.setAsyncState({ messagePage: page })
            this.loadMessages()
        } catch (error) {
            console.log('SetFiltersAndPage Error: ', error)
        }
    }

    /**
     * get rated tickets
     */
    async loadRatedTickets(dateRange, page) {
        try {
            const { user } = this.state
            if (!user) return null
            return await this.api.messageService.getRatedTickets(dateRange, page)
        } catch (error) {
            console.log('Load rated tickets Error: ', error)
        }
    }



    render() {
        const { ready, user, messages, messageFilters, messagePage, ratedTickets } = this.state
        const api = this.api

        return (

            <PageContext.Provider
                value={{
                    ready, user, messages, api, messageFilters, messagePage, ratedTickets,
                    loadMessages: this.loadMessages.bind(this),
                    setMessageFilters: this.setMessageFilters.bind(this),
                    setMessagePage: this.setMessagePage.bind(this),
                    loadRatedTickets: this.loadRatedTickets.bind(this)
                }}>
                {ready && (
                    <div>

                        {this.props.children}

                    </div>
                )}

            </PageContext.Provider>

        )
    }
}

const PageConsumer = PageContext.Consumer

export default withTranslation()((withRouter(PageProvider)))
export { PageConsumer }